import { render, staticRenderFns } from "./UserHealthcare.vue?vue&type=template&id=78fd653c&scoped=true"
import script from "./UserHealthcare.vue?vue&type=script&lang=js"
export * from "./UserHealthcare.vue?vue&type=script&lang=js"
import style0 from "./UserHealthcare.vue?vue&type=style&index=0&id=78fd653c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd653c",
  null
  
)

export default component.exports